import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-gg';

@Component({
  selector: 'app-predictive-mobile-search-component',
  templateUrl: './predictive-mobile-search-component.component.html',
  styleUrls: ['./predictive-mobile-search-component.component.scss']
})
export class PredictiveMobileSearchComponentComponent implements OnChanges {
  @ViewChild('dropdownRef') dropdownRef!: ElementRef;
  @Output() selectMobileNumber = new EventEmitter<{ data: any }>();
  @Output() inputSearch = new EventEmitter<{ data: any }>();
  @Output() isRestForm = new EventEmitter<boolean>();
  @Output() resetHandled = new EventEmitter<void>();
  @Input() filteredMobile: any[] = [];
  @Input() isLoading: boolean = false;
  @Input() resetNumberOnEmailChange: boolean = false;
  @Input() groupUserId: string = '';
  @Input() isEmailSearch:boolean = false;
  isShowDropdown: boolean = true;
  nationalNumber: PhoneNumberFormat;
  searchCountryField = SearchCountryField;
  countryISO: CountryISO = CountryISO.UnitedStates;
  phoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  separateDialCode: boolean = false;
  mobileSearchForm: FormGroup
  cleanedNumber: string = '';
  activeIndex: number = -1;

constructor(private readonly formBuilder: FormBuilder) {
    this.mobileNumberFromGroup();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetNumberOnEmailChange'] &&
      changes['resetNumberOnEmailChange'].currentValue === true) {
      this.mobileSearchForm.get('phone')?.setValue('');
      this.mobileSearchForm.get('phone')?.enable();
      this.resetHandled.emit();
    }

    if (changes['filteredMobile']?.currentValue && this.filteredMobile) {
      if(this.isEmailSearch){
         this.patchMobileNumber();
      }
    }
  }

  mobileNumberFromGroup(): void {
    this.mobileSearchForm = this.formBuilder.group({
      phone: ['']
    });
  }

  private patchMobileNumber(): void {
    if (this.filteredMobile[0]?.message === "") {
      const mobileNumber = this.filteredMobile[0]?.mobileNumber;
      this.mobileSearchForm.patchValue({
        phone: mobileNumber
      });
      this.mobileSearchForm.get('phone')?.disable();
      this.filteredMobile = [];
    }
  }

    onMobileSelectionChange(res): void {
    this.mobileSearchForm.patchValue({
      phone: res.mobileNumber,
    })
    this.selectMobileNumber.emit({ data: res });
  }

  onMobileTyping(event: any): void {
    this.activeIndex = -1
    const input: string = event?.target?.value ?? "";

    if (input === "") {
      this.filteredMobile = [];
    }

    const phoneControlValue = this.mobileSearchForm.get('phone')?.value;
    if (phoneControlValue) {
      const { dialCode, number } = phoneControlValue;
      this.patchDialCode(dialCode, number);
      this.inputSearch.emit({ data: { dialCode, number: number, cleanedNumber: this.cleanedNumber ,iso: phoneControlValue.countryCode
} });
    }
    else{
      this.inputSearch.emit({ data: { dialCode: '', number: '',cleanedNumber: '' ,iso:''} });
    }
  }

  patchDialCode(dialCode: string, number: string): string {
    this.cleanedNumber = number;
    if (this.cleanedNumber.startsWith(dialCode)) {
      this.cleanedNumber = this.cleanedNumber.slice(dialCode.length);
    }
    return this.cleanedNumber;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.filteredMobile?.length && this.dropdownRef) {
      const clickedInside = this.dropdownRef.nativeElement.contains(event.target);
      if (!clickedInside) {
        this.filteredMobile = []; // Or set a visibility flag to false
      }
    }
  }
   onKeyDown(event: KeyboardEvent): void {
    const dropdownLength = this.filteredMobile?.length || 0;

    if (dropdownLength === 0) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.activeIndex = (this.activeIndex + 1) % dropdownLength;
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.activeIndex = (this.activeIndex - 1 + dropdownLength) % dropdownLength;
        break;
      case 'Enter':
        event.preventDefault();
        if (this.activeIndex >= 0 && this.filteredMobile[this.activeIndex]) {
          this.onMobileSelectionChange(this.filteredMobile[this.activeIndex]);
        }
        break;
    }
  }

  onFocusIn(): void {
    this.isShowDropdown = true;
    this.filteredMobile = [];
  }

  onFocusOut(): void {
    setTimeout(() => {
      this.isShowDropdown = false;
    }, 150);
  }
}
